var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWarningIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 52 52"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "WarningIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h52v52H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#WarningIcon_svg__a)",
  "data-name": "Artboard - 9"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h52v52H0z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 21631"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 21495"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f5881f",
  d: "M25.422 12.227h9.185a.474.474 0 0 0 .533-.474 3.08 3.08 0 0 0-1.067-2.311l-7.7-6.459a3.44 3.44 0 0 0-2.14-.711.71.71 0 0 0-.711.711v7.348a1.9 1.9 0 0 0 1.9 1.9Z",
  "data-name": "Path 71718"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f5881f",
  d: "M34.541 23.132h.6v-8.237h-9.722a4.62 4.62 0 0 1-4.563-4.563V2.213H7.641a3.26 3.26 0 0 0-3.2 3.259v33.956a3.26 3.26 0 0 0 3.2 3.259h14.7a12.5 12.5 0 0 1-1.422-5.926 14.03 14.03 0 0 1 13.622-13.629",
  "data-name": "Path 71719"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f5881f",
  d: "M35.968 25.501h-.533a12.15 12.15 0 0 0-12.149 12.148 12.4 12.4 0 0 0 1.3 5.511 12.148 12.148 0 1 0 11.382-17.659",
  "data-name": "Path 71720"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#07152a",
  "data-name": "!",
  fontFamily: "Muli-SemiBold, Muli",
  fontSize: 18,
  fontWeight: 600,
  letterSpacing: ".02em",
  transform: "translate(35.423 44.1)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -2.848,
  y: 0
}, "!")))))));
export default SvgWarningIcon;